import { PageController } from '@client/components/_core/layout/PageController';
import { NoteEdit } from '@client/components/claims/NoteEdit';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useClaimInteractionAccess } from '../../useClaimInteractionAccess';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/manage/strategies/add')({
    component: StrategyAdd,
});

function StrategyAdd() {
    const { id } = Route.useParams();
    const orgId = useOrgId();
    const { trpcUtils } = useTrpc();
    const navigate = useNavigate();
    const { canEdit } = useClaimInteractionAccess();

    const [open, setOpen] = useState(true);

    // CUR-725: closed claims are read-only — no new strategies.
    useEffect(() => {
        if (!canEdit) {
            navigate({ moveInMatches: -1 });
        }
    }, [canEdit]);

    return (
        <PageController route={Route}>
            <NoteEdit
                entityId={id}
                entity="claim"
                open={open && canEdit}
                type="STRATEGY"
                title="Add strategy"
                onClose={() => {
                    setOpen(false);
                    trpcUtils.note.invalidate();

                    navigate({
                        to: '/console/$orgId/claims/details/$id/manage',
                        params: {
                            orgId,
                            id,
                        },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
